import { BlockOverrides } from 'baseui/block';
import { THEME } from '@lyon/utils/theme';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      display: 'grid',
      gridColumnGap: '24px',
      gridTemplateColumns: '1fr',
      transition: 'all 200ms',
      borderBottomRightRadius: '4px',
      borderBottomLeftRadius: '4px',

      ':hover': {
        opacity: 0.8,
        cursor: 'link',
      },

      [THEME.media.small]: {
        display: 'block',
      },
    },
  },
};
